import { render, staticRenderFns } from "./M2MReportTemplate.vue?vue&type=template&id=6b7bc79a"
import script from "./M2MReportTemplate.vue?vue&type=script&lang=js"
export * from "./M2MReportTemplate.vue?vue&type=script&lang=js"
import style0 from "./M2MReportTemplate.vue?vue&type=style&index=0&id=6b7bc79a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports